import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@design-system/buttons/icon/icon.component';

@Component({
  selector: 'app-warning-icon',
  templateUrl: './warning-icon.component.html',
  styleUrls: ['./warning-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    IconComponent
  ]
})
export class WarningIconComponent {}
